export const getDirValue = (isRTL: boolean): string => {
  /* istanbul ignore next */
  return isRTL ? 'rtl' : 'ltr';
};
